<template>
  <div style="margin: 10px">
    <v-card>
      <v-form ref="viewPresentForm">
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">{{
              $t(formName)
              }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="position: absolute; right: 10px; top: 10px; color: #fff"
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs6>
              <v-text-field
                  :data-vv-as="$t('Mã quy trình')"
                  :error-messages="errors.first('code')"
                  :label="$t('Mã quy trình')"
                  disabled
                  maxLength="250"
                  name="code"
                  type="text"
                  v-model.trim="item.code"
                  v-validate="'required'"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-select
                  :data-vv-as="$t('lang.procedureWh.numberG')"
                  :error-messages="errors.first('numberG')"
                  :items="numberGList"
                  :label="$t('lang.procedureWh.numberG')"
                  item-text="text"
                  item-value="value"
                  name="numberG"
                  ref="numberG"
                  v-model="item.numberG"
                  v-on:change="onViewProcedure"
              />
            </v-flex>

          </v-layout>
          <div style="text-align: right">

          </div>
        </v-card-text>
        <table v-if="lstMaterial.length > 0">
          <tr>
            <td style="height: 50px">
              <label style="font-weight: bold ; color: black;">
                Danh sách vật tư ao Mẹ
              </label>
            </td>
          </tr>
        </table>
        <v-data-table
            :headers="lstMaterial"
            :items="lstMotherDay"
            class="procedure_index_tb"
            hide-actions
            id="parentDay"
            v-if="lstMaterial.length > 0"
        >
          <template slot="headers">
            <tr>
              <th class="fixed" colspan="2" style="text-align:center; background: powderblue; border : 1px solid grey">
                <label style="font-weight: bold; color: black;">
                  Ao mẹ
                </label>

              </th>
              <th :colspan="type.count" style="text-align:center; background: powderblue; border : 1px solid grey"
                  v-for="type in lstType">
                <label style="font-weight: bold; color: black;">
                  <select-box-view
                      :keyValue="type.typeId"
                      :listObject="listMaterialType"
                  />
                </label>

              </th>
            </tr>
            <tr>
              <th class="fixed" style=" border : 1px solid grey; color: black; background: lightgrey"
                  v-if="lstMaterial.length > 0">
                Ngày
              </th>
              <th class="fixed2" style=" border : 1px solid grey; color: black; background: lightgrey"
                  v-if="lstMaterial.length > 0">
                Tuổi tôm
              </th>
              <th style=" border : 1px solid grey; color: black; background: white" v-for="header in lstMaterial">
                <select-box-view class="labelText"
                    :keyValue="header.materialId"
                    :listObject="listObject"
                />
              </th>
            </tr>

          </template>
          <template v-slot:items="props">
            <procedure-wh-day-list-item :ref="'dayItem' +props.index" :row="props"/>
          </template>
        </v-data-table>
        <table v-if="lstMaterial.length > 0">
          <tr>
            <td style="height: 50px">
              <label style="font-weight: bold ; color: black;">
                Danh sách vật tư ao con
              </label>
            </td>
          </tr>
        </table>
        <v-data-table
            :headers="lstMaterial"
            :items="lstChildrenDay"
            class="procedure_index_tb"
            hide-actions
            id="childrenDay"
            v-if="lstMaterial.length > 0"
        >
          <template slot="headers">
            <tr>
              <th class="fixed" colspan="2" style="text-align:center; background: powderblue; border : 1px solid grey">
                <label style="font-weight: bold; color: black;">
                  Ao con
                </label>

              </th>
              <th :colspan="type.count" style="text-align:center; background: powderblue; border : 1px solid grey"
                  v-for="type in lstType">
                <label style="font-weight: bold; color: black;">
                  <select-box-view
                      :keyValue="type.typeId"
                      :listObject="listMaterialType"
                  />
                </label>

              </th>
            </tr>
            <tr>
              <th class="fixed" style=" border : 1px solid grey; color: black; background: lightgrey"
                  v-if="lstMaterial.length > 0">
                Ngày
              </th>
              <th class="fixed2" style=" border : 1px solid grey; color: black; background: lightgrey"
                  v-if="lstMaterial.length > 0">
                Tuổi tôm
              </th>
              <th style=" border : 1px solid grey; color: black; background: white" v-for="header in lstMaterial">
<!--                <label class="labelText" > 123123 123213 21213 12312 213</label>-->
                <select-box-view class="labelText"
                    :keyValue="header.materialId"
                    :listObject="listObject"
                />
              </th>
            </tr>

          </template>
          <template v-slot:items="props">
            <procedure-wh-day-list-item :ref="'dayItem' +props.index" :row="props"/>
          </template>
        </v-data-table>

        <div style="text-align: right">
          <v-btn @click="onCancel" color="error">
            <v-icon dark left>keyboard_backspace</v-icon>
            {{ $t("lang.common.back") }}
          </v-btn>
        </div>
      </v-form>

    </v-card>
    <go-top></go-top>
  </div>
</template>

<script>
  import {message} from "../../../services";
  import axios from "axios";
  import {areaContants} from "@/constants";
  import {mapGetters} from "vuex";
  import ProcedureWhDayListItem from "./component/ProcedureWhDayListItem";
  import SelectBoxView from "../../../components/form/SelectBoxView";
  import {router} from "../../../router";
  import GoTop from '@inotom/vue-go-top';

  export default {
    name: "procedure-wh-day-list-view",
    components: {SelectBoxView, ProcedureWhDayListItem, message, axios, GoTop},
    props: {
      propsItem: {
        type: Object,
        default: () => {
                    return {}
                }
      },
      cDialog: {
        type: Boolean,
        default: false,
      },
      areas: {
        type: Array,
        default: ()=> [],
      },
      rowsPerPageItems: {
        type: [Array, Number],
        default: () => [10, 20, 30, 40, 50]
      },
      timeReload: {
        type: [Number],
        default: 0
      }
    },
    data: () => {
      return {
        formName: "Xem quy trình",
        areaStatus: areaContants.areaStatus,
        numberGList: areaContants.numberGList,
        item: {
          status: 1,
        },
        inDialog: false,
        searchItems: [],
        createItems: [],
        listObject: [],
        listMaterialType: [],
        searchUrl: "",
        materialTypes: [],
        numberColumnSpanAll: 3,
        fields: [
          {
            value: "index",
            text: "lang.common.index",
            width: "5%",
            sortable: false,
          },

          {
            type: "select",
            items: [],
            itemText: "name",
            itemValue: "id",
            name: 'typeId',
            value: 'typeId',
            text: 'lang.request.typeId',
            width: "10%",
            sortable: false,
            search: true,
          },

          {
            type: "select",
            items: [],
            itemText: "name",
            itemValue: "id",
            name: 'materialId',
            value: 'materialId',
            text: 'lang.request.materialId',
            width: "10%",
            sortable: false,
            search: true,
          },
          {
            value: 'custom_action',
            text: "lang.request.delete",
            icon: "delete",
            event: "onDeleteFromProcedure",
            width: "10%",
            color: "primary"
          }
        ],
      };
    },
    computed: {
      ...mapGetters({
        lstMotherDay: 'procedureWh/lstMotherDay',
      }),
      ...mapGetters({
        lstChildrenDay: 'procedureWh/lstChildrenDay',
      }),
      ...mapGetters({
        lstMaterial: 'procedureWh/lstMaterial',
      }),
      ...mapGetters({
        lstType: 'procedureWh/lstType',
      }),
      ...mapGetters({
        isView: 'procedureWh/isView',
      }),


    },
    // watch: {
    //   propsItem: {
    //     handler(value) {
    //       //console.log(value);
    //       if (value !== null && value !== undefined) {
    //         this.item = Object.assign({}, value)
    //         this.$store.dispatch("procedureWh/setProcedureWhModel", {});
    //       }
    //     },
    //     deep: true,
    //
    //
    //   },
    //   cDialog(value) {
    //     this.inDialog = value;
    //   },
    //   inDialog(value) {
    //     if (!value) {
    //       this.$emit("closeDialog", "");
    //     }
    //   },
    // },
    methods: {
      resetFrom: function () {
        this.item = {
          status: 1,
        };
      },
      extractValueFromData(value) {
        let data = value.data;
        value.data = "";
        if (data != null && data != undefined && data != "") {
          let ob2 = JSON.parse(data);
          return Object.assign(value, ob2);
        }
        return value

      },

      onCancel: function () {
        //router.push("/procedureWh");
        router.push({ path: `/procedureWh`, query: this.$route.query });
        //this.$emit("closeDialog", "");
      },
      onViewProcedure: function () {
        if (this.item.numberG == undefined || this.item.numberG == null || this.item.numberG == "") {
          //message.error(this.$t("lang.common.validate_fail"));
          this.$refs.numberG.focus()
          return;
        }

        let procedureId = this.item.procedureId
        let objectSearch = new Object();
        objectSearch.numberG = this.item.numberG;
        axios.post(
          process.env.VUE_APP_API_URL +
          "/procedureWh/detail/" + procedureId,
          objectSearch
        ).then((data) => {
            //alert(JSON.stringify(data))
            if (data.lstMotherDay) {
              for (let i = 0; i < data.lstMotherDay.length; i++) {
                data.lstMotherDay[i] = this.extractValueFromData(data.lstMotherDay[i]);
              }
            }
            if (data.lstChildrenDay) {
              for (let i = 0; i < data.lstChildrenDay.length; i++) {
                data.lstChildrenDay[i] = this.extractValueFromData(data.lstChildrenDay[i]);
              }
            }
            this.$store.dispatch("procedureWh/setProcedureWhModel", data);
          }
        );
      },


    },
    created() {
      if (this.$route.params.id) {
        this.$store.commit("procedureWh/setIsView", 1);
        this.$store.dispatch("procedureWh/setProcedureWhModel", {});
        axios.post(process.env.VUE_APP_API_URL + "/procedureWh/search?pageSize=-1&page=-1", {"procedureId": this.$route.params.id}).then(
          data => {
            if (data.count == 1) {
              this.item = Object.assign({}, data.items[0])

            }
          }
        )
      }

      axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/materialType", {}).then(
        data => {
          let itemFields = this.fields.filter(function (e) {
            return e.name == "typeId";
          });
          if (itemFields != undefined && itemFields.length > 0) {
            itemFields[0].items = data.items;
          }
          this.materialTypes = data.items;

          this.listMaterialType.push({"itemValue": "id", "itemText": "name", "items": data.items});

        }
      )
      axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/material", {}).then(
        data => {
          let itemFields = this.fields.filter(function (e) {
            return e.name == "materialId";
          });
          if (itemFields != undefined && itemFields.length > 0) {
            itemFields[0].items = data.items;
          }
          this.listObject.push({"itemValue": "id", "itemText": "name", "unitText": "name2", "items": data.items});
          this.numberColumnSpanAll = data.items.length + 2;
        }
      )
    },
  };
</script>
<style>
</style>